import { getPropertySyncMode } from '@common/util/property'
import { LocalStorageKey } from '~/components/hooks/useLocalStorage'
import { PropertyProfileFragment, PropertySyncMode } from '~/graphql/generated/query.types'

export function getPropertyLabel(property: PropertyProfileFragment) {
  const propertySyncMode = getPropertySyncMode(property)
  const label =
    propertySyncMode === PropertySyncMode.disabled ? `${property.name} (disabled)` : property.name
  return label
}

export function clearLocalStoragePropertyRelatedValues() {
  localStorage?.removeItem(LocalStorageKey.PROPERTY_SID)
  localStorage?.removeItem(LocalStorageKey.PORTFOLIO_SID)
  localStorage?.removeItem(LocalStorageKey.RENEWALS_PROPERTY_SID)
}
